const initState = {
  menuPosicion: 1
};

export default initState;
